import { useAtom } from "jotai";

import selectedStoreAtom from "../jotai/atoms/selectedStoreAtom";
import ecomWebAppJotaiStore from "../../../jotai/ecom-web-app-jotai-store";

const useSelectedStore = () => {
  const [selectedStore, setSelectedStore] = useAtom(selectedStoreAtom, {
    store: ecomWebAppJotaiStore,
  });

  return { selectedStore, setSelectedStore };
};

export default useSelectedStore;
